const company = "Qurasoft GmbH";
const qurasoftStreet = "Im Metternicher Feld 30c";
const qurasoftCity = "D-56072 Koblenz";

export {
  company,
  qurasoftCity,
  qurasoftStreet
};
